import { NumericNegative1Icon } from './NumericNegative1Icon';

/**
 * author: Contributors
 * id B198FE0B-15C3-4FFB-B5C9-2D6E60E825A1
 * name numeric-negative-1
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-negative-1.svg
 * tags
 * - Alpha / Numeric 
 */
export const MinusOneIcon = NumericNegative1Icon;
export default MinusOneIcon